










































import { dayjs, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { Vue, Component } from 'vue-property-decorator';
import { BBSDTO } from '../../../src_server/entity/dto/BBSDTO';
import { BBSService } from '../../biz/remote/BBSService';
import { TeacherBbs } from '../../../src_server/entity/generated/TeacherBbs';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { Session } from '../../utils/Session';
import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { TeacherService } from '../../biz/remote/TeacherService';
import { use } from 'vue/types/umd';

@Component({
  components: { CommonDialog },
  filters: {
    formatDt: (dt: Date) => {
      return dayjs(dt).format(DT_FORMAT_JA);
    },
    fromNow: (dt: Date) => {
      return dayjs(dt).fromNow();
    },
  },
})
export default class BBSPage extends Vue {
  newTitle = '';
  newMessage = '';

  private rows: BBSDTO[] = [];

  async commitAddThread() {
    const user_id = 'TEA'; //Session.getSessionUserId();
    const biz = new BBSService();
    const teacherBiz = new TeacherService();

    const bbs = new TeacherBbs();
    bbs.user_id = user_id;
    bbs.thread_dt = new Date();
    bbs.title = this.newTitle;
    bbs.message = this.newMessage;
    bbs.is_base = true;
    biz.addNewThread(bbs);
    this.newTitle = '';
    this.newMessage = '';
    const dto = new BBSDTO();
    dto.bbs = bbs;

    const tea = new Teacher();
    tea.user_id = bbs.user_id;
    tea.nickname = Session.getSessionNickName();
    const teacherResponse = await teacherBiz.getTeacher(user_id);
    dto.teacher = teacherResponse.data.teacher;

    this.rows.unshift(dto);
    this.close();
  }

  addSubThread() {
    const biz = new BBSService();
    const teacherBiz = new TeacherService();
    const bbs = new TeacherBbs();
    bbs.user_id = '';
    bbs.thread_dt = new Date();
    bbs.title = '';
    bbs.message = '';
    bbs.parent_thread_id = 1;
    bbs.is_base = false;
    biz.addNewThread(bbs);
  }

  async loadData() {
    const biz = new BBSService();
    const result = await biz.getAllThread();
    this.rows = result.data.sort((a, b) => {
      const adt = a.bbs.thread_dt;
      const bdt = b.bbs.thread_dt;
      if (!adt || !bdt) return 0;
      if (adt === bdt) return 0;
      if (adt > bdt) return -1;
      else return 1;
    });
  }

  created() {
    this.loadData().then();
  }

  public async show() {
    (this.$refs['dialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['dialog'] as CommonDialog).hide();
  }
}
